import script from "./TickOrCross.vue?vue&type=script&setup=true&lang=js"
export * from "./TickOrCross.vue?vue&type=script&setup=true&lang=js"

import "./TickOrCross.vue?vue&type=style&index=0&id=13b29c09&lang=css"

const __exports__ = script;

export default __exports__